import React from "react";
import { Box } from "@mui/material";
import { Form, Formik } from "formik";

import Layout from "@components/Layout";
import BreadcrumbAndTitle from "@components/BreadcrumbAndTitle";
import { BreadcrumbChild } from "@components/BreadcrumbCustom";
import ROUTES from "@config/routes";

import { AppointmentPriceProvider } from "./context/AppointmentPriceContext";
import { FormQuery } from "./components/FormQuery";
import { FormQueryPricesValidationSchema } from "./validation/FormQueryPricesValidationSchema";
import { TablePrices } from "./components/TablePrices";
import { IQuery } from "./interface";

const breadcrumbData: BreadcrumbChild[] = [
  { link: ROUTES.USER_ROUTES.HOME, label: "Início" },
  { label: "Preços de produtos Atem" },
];

const initialValues: IQuery = {
  CNPJ: "",
  address: null,
  filialID: "",
  withdrawBasisID: "",
  withdrawBasisBranchName: "",
  freightType: null,
};

const containerSx = {
  margin: { xs: 0, sm: "0 2rem", md: "0 4rem" },
  width: { xs: "100%", sm: "auto" },
  padding: { xs: "1rem", sm: "1rem" },
};

const PageContainer: React.FC = () => (
  <Layout>
    <Box sx={containerSx}>
      <BreadcrumbAndTitle
        breadcrumbData={breadcrumbData}
        title="Preços de produtos Atem"
      />
    </Box>
    <Box sx={containerSx}>
      <Formik
        initialValues={initialValues}
        validationSchema={FormQueryPricesValidationSchema}
        onSubmit={async () => {}}
      >
        <Form>
          <FormQuery />
          <TablePrices />
        </Form>
      </Formik>
    </Box>
  </Layout>
);

const AppointmentPrice: React.FC = () => (
  <AppointmentPriceProvider>
    <PageContainer />
  </AppointmentPriceProvider>
);

AppointmentPrice.displayName = "AppointmentPrice";

export { AppointmentPrice };
